import React from 'react';
import { Line } from 'react-konva';
import { useCanvasStore } from '../../store/canvasStore';
import { useEditorStore } from '../../store/editorStore';
import { THEMES } from '../../floorplanTheme';
import { DEFAULT_WALL_THICKNESS } from '../../canvasConstants';
import type { CanvasShape } from '../../types';

interface WallShapeProps {
  shape: CanvasShape;
  onCanvasChange?: () => void;
}

const WallShape: React.FC<WallShapeProps> = ({ shape, onCanvasChange }) => {
  const { removeShape, pushHistory } = useCanvasStore();
  const { selectedIds, setSelectedIds, activeTool, canvasTheme } = useEditorStore();
  const theme = THEMES[canvasTheme];
  const isSelected = selectedIds.includes(shape.id);
  const points = shape.points ?? [];

  const handleSelect = () => {
    if (activeTool === 'select') setSelectedIds([shape.id]);
    if (activeTool === 'eraser') {
      removeShape(shape.id);
      pushHistory();
      onCanvasChange?.();
    }
  };

  if (points.length < 4) return null; // Need at least 2 points (x1,y1,x2,y2)

  const thickness = shape.thickness ?? DEFAULT_WALL_THICKNESS;

  return (
    <>
      {/* Selection halo sits behind the wall body. */}
      {isSelected && (
        <Line
          points={points}
          stroke={theme.wall.selectedStroke}
          strokeWidth={thickness + 6}
          opacity={0.4}
          lineCap="butt"
          lineJoin="miter"
          listening={false}
        />
      )}
      {/* Solid wall body. */}
      <Line
        points={points}
        stroke={theme.wall.stroke}
        strokeWidth={thickness}
        lineCap="butt"
        lineJoin="miter"
        hitStrokeWidth={Math.max(thickness, 16)}
        listening={true}
        onClick={handleSelect}
        onTap={handleSelect}
      />
    </>
  );
};

export default WallShape;
